import React from "react";
import { CampaignWizardMode, ProjectStatusE, StatusE } from "../../models/enums";
import CampaignWizard from "./CampaignWizard";
import CampaignWizardFooter from "./CampaignWizardFooter";
import usePopup from "../../utils/hooks/usePopup";

import styles from './campaignWizard.module.scss';

export const useCampaignWizard = () => {
    const { createPopup } = usePopup();

    const createCampaignWizard = (
        projectId: number | string | null,
        mode: CampaignWizardMode,
        projectStatus?: StatusE | ProjectStatusE,
    ) => createPopup({
        header: <></>,
        body: <CampaignWizard projectId={+projectId} mode={mode} />,
        footer: <CampaignWizardFooter
            mode={mode}
            projectStatus={projectStatus}
        />,
        className: styles.campaignWizardPopupWrapper,
    });

    return {
        createCampaignWizard,
    };
};